// Context-aware payment status & method labels for customer-facing order views.

export const getPaymentMethodLabel = (method) => {
  switch (method) {
    case 'pod':
      return 'Cash on Delivery';
    case 'upi':
      return 'UPI / GPay';
    case 'whatsapp':
      return 'WhatsApp Checkout';
    case 'stripe':
      return 'Card';
    default:
      return 'Cash on Delivery';
  }
};

// Returns a context-aware label + tailwind color class for the payment status.
export const getPaymentDisplay = (order) => {
  const method = order?.payment_method;
  const status = order?.payment_status;

  if (status === 'paid') {
    if (method === 'upi') return { label: 'Paid via GPay', color: 'text-green-600' };
    return { label: 'Paid', color: 'text-green-600' };
  }
  if (status === 'pay_on_delivery' || method === 'pod') {
    return { label: 'Cash on Delivery', color: 'text-blue-600' };
  }
  if (status === 'awaiting_verification') {
    return { label: 'Awaiting Verification', color: 'text-orange-600' };
  }
  if (method === 'whatsapp') {
    return { label: 'Order via WhatsApp', color: 'text-green-600' };
  }
  if (status === 'failed') return { label: 'Failed', color: 'text-red-600' };
  if (status === 'refunded') return { label: 'Refunded', color: 'text-purple-600' };
  return { label: 'Pending', color: 'text-yellow-600' };
};
